// Dependencies
import React from 'react';
import radium from 'radium';
import {connect} from 'react-redux';
import Hammer from '../../mocks/HammerMock';

import SeatingplanElements from './SeatingplanElements.jsx';
import EventPageSeatingplanBtn from './EventPageSeatingplanBtn.jsx';
import CategoryDropDown from './category-selection/CategoryDropDown.jsx';

import FreeSeatingAmountSelection from './FreeSeatingAmountSelection.jsx';
import LeoPopup from '../../components/popup/LeoPopup.jsx';

import AccessCodeForm from '../event/accessCode/AccessCodeForm.jsx';

import {deleteMessage, setSeatInSelection, toggleShowFreeSeatingPopup} from '../../redux/seatingplanPageReducer';
import Messages from '../../components/messages/Messages';
import SeatPricelevelSelection from './seat/SeatPricelevelSelection.jsx';
import Button from '../../components/button/Button.tsx';
import history from '../../lib/history';
import ZigZagBox from '../../components/zig-zag-box/ZigZagBox.jsx';
import {ThemeContext} from '../../components/theme/Theme.jsx'
import {getSeatIdentifier} from "./Seat";

// Styles
import './SeatingplanDisplayPage.scss';
import sponsorCodeService from "../../lib/sponsorCodes-service.js";

class SeatingplanDisplayPage extends React.Component {
	static contextType = ThemeContext;

	constructor(props) {
		super(props);
		this.state = {
			zoomFactor: 1,
			startX: 0,
			startY: 0,
			enteringAccessCode: false,
			viewBoxAnimationViewBoxTo: '',
			viewBoxAnimationViewBoxFrom: ''
		};
	}


	componentDidMount() {
		const myOptions = {};
		this.ctm = this.el.getScreenCTM();
		this.hammer = new Hammer.Manager(this.el, myOptions);
		this.hammerTap = this.hammer.add(new Hammer.Tap({event: 'doubletap', taps: 2, interval: 1000}));
		this.hammerPinch = this.hammer.add(new Hammer.Pinch());
		this.hammerPan = this.hammer.add(new Hammer.Pan({direction: Hammer.DIRECTION_ALL, threshold: 10}));

		const panFunc = this.onPan.bind(this);
		const panStartFunc = this.onPanStart.bind(this);
		const pinchFunc = this.onPinch.bind(this);
		const pinchedFunc = this.onPinched.bind(this);
		const pinchStartFunc = this.onPinchStrart.bind(this);
		const tapFunc = this.onDoubleTap.bind(this);
		const onMouseWheel = this.onMouseWheel.bind(this);
		this.hammer.on('doubletap', tapFunc);
		this.hammer.on('pan panend', panFunc);
		this.hammer.on('panstart', panStartFunc);
		this.hammer.on('pinchstart', pinchStartFunc);
		this.hammer.on('pinchend', pinchedFunc);
		//this.hammer.on('pinchstart pinchend', pinchFunc);
		this.hammer.on('pinch', pinchFunc);
		this.el.addEventListener('wheel', onMouseWheel);
		if (this.props.starSeats.length > 0) {
			this.setNewZoomForStarSeats(this.props.starSeats);
		}

	}

	onDoubleTap(event) {
		this.setState((prevState) => {
			const newZoom = prevState.zoomFactor !== 1 ? 1 : 3;
			const scalechange = (newZoom / prevState.zoomFactor);

			const svgPoint = this.el.createSVGPoint();
			svgPoint.x = event.center.x;
			svgPoint.y = event.center.y;
			this.ctm = this.el.getScreenCTM();

			const mouseInSvg = svgPoint.matrixTransform(this.ctm.inverse());

			const scaleMatrix = this.el.createSVGMatrix()
				.translate(prevState.startX, prevState.startY)
				.scale(scalechange);

			const newCtm = this.ctm.multiply(scaleMatrix);

			const newMouseInSvg = svgPoint.matrixTransform(newCtm.inverse());

			return {
				startX: (mouseInSvg.x - newMouseInSvg.x), startY: (mouseInSvg.y - newMouseInSvg.y), zoomFactor: newZoom,
			};
		});
	}

	onMouseWheel(event) {
		event.preventDefault(); // Needed for Zoom on mac
		this.setState((prevState) => {
			const baseZoomFactor = prevState.zoomFactor;
			// 50 deltaY shoud be 10% zoom
			// deltaMode ist 0 wenn deltaY Pixel sind
			// 1 wenn deltaY Zeilen sind und 2 wenn deltaY Seiten sind.
			// siehe: https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode  FF nutzt deltaMode 1 Chrome deltaMode 0
			const deltaY = event.deltaMode > 0 ? event.deltaY * 25 : event.deltaY;
			const scrollFactor = ((0.1 / 50) * -deltaY) + 1;
			const newZoom = baseZoomFactor * scrollFactor;
			if (newZoom < 0.1 || newZoom > 100) {
				return prevState;
			}
			const svgPoint = this.el.createSVGPoint();
			svgPoint.x = event.clientX;
			svgPoint.y = event.clientY;
			const ctm = this.el.getScreenCTM();
			const mouseInSvg = svgPoint.matrixTransform(ctm.inverse());

			const scaleMatrix = this.el.createSVGMatrix()
				.translate(prevState.startX, prevState.startY)
				.scale(scrollFactor);
			const newCtm = ctm.multiply(scaleMatrix);

			const newMouseInSvg = svgPoint.matrixTransform(newCtm.inverse());
			return {
				zoomFactor: newZoom,
				startX: (mouseInSvg.x - newMouseInSvg.x),
				startY: (mouseInSvg.y - newMouseInSvg.y),
				baseZoomFactor,
			};
		});
	}

	onPinchStrart(event) {
		this.setState((prevState) => {
			let baseZoomFactor;
			this.hammerPan.set({enable: false});
			baseZoomFactor = prevState.zoomFactor;
			const newZoom = baseZoomFactor * event.scale;
			const scalechange = (newZoom / prevState.zoomFactor);
			const svgPoint = this.el.createSVGPoint();
			svgPoint.x = event.center.x;
			svgPoint.y = event.center.y;
			const ctm = this.el.getScreenCTM();
			const mouseInSvg = svgPoint.matrixTransform(ctm.inverse());
			const scaleMatrix = this.el.createSVGMatrix()
				.translate(prevState.startX, prevState.startY)
				.scale(scalechange);
			const newCtm = ctm.multiply(scaleMatrix);
			const newMouseInSvg = svgPoint.matrixTransform(newCtm.inverse());
			return {
				zoomFactor: newZoom,
				startX: (mouseInSvg.x - newMouseInSvg.x),
				startY: (mouseInSvg.y - newMouseInSvg.y),
				baseZoomFactor,
			};
		});
	}

	onPinched(event) {
		this.setState((prevState) => {
			let baseZoomFactor = prevState.baseZoomFactor;
			setTimeout(() => {
				this.hammerPan.set({enable: true});
			}, 200);
			const newZoom = baseZoomFactor * event.scale;
			const scalechange = (newZoom / prevState.zoomFactor);
			const svgPoint = this.el.createSVGPoint();
			svgPoint.x = event.center.x;
			svgPoint.y = event.center.y;
			const ctm = this.el.getScreenCTM();
			const mouseInSvg = svgPoint.matrixTransform(ctm.inverse());
			const scaleMatrix = this.el.createSVGMatrix()
				.translate(prevState.startX, prevState.startY)
				.scale(scalechange);
			const newCtm = ctm.multiply(scaleMatrix);
			const newMouseInSvg = svgPoint.matrixTransform(newCtm.inverse());
			return {
				zoomFactor: newZoom,
				startX: (mouseInSvg.x - newMouseInSvg.x),
				startY: (mouseInSvg.y - newMouseInSvg.y),
				baseZoomFactor,
			};
		});
	}

	onPinch(event) {
		this.setState((prevState) => {
			let baseZoomFactor = prevState.baseZoomFactor;
			if (event.type === 'pinchstart') {
				this.hammerPan.set({enable: false});
				baseZoomFactor = prevState.zoomFactor;
			}
			if (event.type === 'pinchend') {
				setTimeout(() => {
					this.hammerPan.set({enable: true});
				}, 200);
			}

			const newZoom = baseZoomFactor * event.scale;
			const scalechange = (newZoom / prevState.zoomFactor);

			const svgPoint = this.el.createSVGPoint();
			svgPoint.x = event.center.x;
			svgPoint.y = event.center.y;
			const ctm = this.el.getScreenCTM();
			const mouseInSvg = svgPoint.matrixTransform(ctm.inverse());

			const scaleMatrix = this.el.createSVGMatrix()
				.translate(prevState.startX, prevState.startY)
				.scale(scalechange);
			const newCtm = ctm.multiply(scaleMatrix);

			const newMouseInSvg = svgPoint.matrixTransform(newCtm.inverse());
			return {
				zoomFactor: newZoom,
				startX: (mouseInSvg.x - newMouseInSvg.x),
				startY: (mouseInSvg.y - newMouseInSvg.y),
				baseZoomFactor,
			};
		});
	}

	onPanStart(event) {
		window.LEO_PAN_END_TIME = null;
		this.setState((prevState) => {
			let mouseInSvgStart;
			let panStartCoords;
			this.ctm = this.el.getScreenCTM();
			this.svgPoint = this.el.createSVGPoint();
			this.svgPoint.x = event.deltaX;
			this.svgPoint.y = event.deltaY;
			const mouseInSvg = this.svgPoint.matrixTransform(this.ctm.inverse());
			mouseInSvgStart = mouseInSvg;
			panStartCoords = {x: prevState.startX, y: prevState.startY};
			const deltaX = mouseInSvgStart.x - mouseInSvg.x;
			const deltaY = mouseInSvgStart.y - mouseInSvg.y;
			const newStartX = panStartCoords.x + deltaX;
			const newStartY = panStartCoords.y + deltaY;

			return {
				startX: newStartX, startY: newStartY, mouseInSvgStart, panStartCoords,
			};
		});
	}

	onPan(event) {
		if (event.type === 'panend') {
			window.LEO_PAN_END_TIME = (+new Date());
		}
		this.setState((prevState) => {
			let mouseInSvgStart = prevState.mouseInSvgStart;
			let panStartCoords = prevState.panStartCoords;
			this.svgPoint.x = event.deltaX;
			this.svgPoint.y = event.deltaY;
			const mouseInSvg = this.svgPoint.matrixTransform(this.ctm.inverse());
			const deltaX = mouseInSvgStart.x - mouseInSvg.x;
			const deltaY = mouseInSvgStart.y - mouseInSvg.y;
			const newStartX = panStartCoords.x + deltaX;
			const newStartY = panStartCoords.y + deltaY;
			return {
				startX: newStartX, startY: newStartY, mouseInSvgStart, panStartCoords,
			};
		});
	}

	getSeatPopupTitle(seatIdentifier) {
		const regex = /^{B}(.*)\u241F{R}(.+)?\u241F{S}(.+)?$/;
		const result = seatIdentifier.match(regex);
		return `Block: ${result[1]} \u2022 Reihe: ${result[2]} \u2022 Sitz: ${result[3]}`;
	}

	getBlockSeatPopupTitle(seatIdentifier) {
		const regex = /^{B}(.*)\u241F{R}(.+)?\u241F{S}(.+)?$/;
		const result = seatIdentifier.match(regex);
		return `Block: ${result[1]} \u2022 Freie Platzwahl`;
	}

	getCurrentViewBoxWidth() {
		return this.props.maxX * (1 / this.state.zoomFactor)
	}

	getCurrentViewBoxHeight() {
		return this.props.maxY * (1 / this.state.zoomFactor)
	}

	getCurrentViewBox() {
		return `${this.state.startX}` + ` ${this.state.startY}` + ` ${this.getCurrentViewBoxWidth()}` + ` ${this.getCurrentViewBoxHeight()}`;
	}

	setNewZoomForStarSeats(starSeats) {
		if ((starSeats.length > 0)) {
			let minX = Math.min(...starSeats.map(item => item.x));
			let maxX = Math.max(...starSeats.map(item => item.x + item.width));
			let minY = Math.min(...starSeats.map(item => item.y));
			let maxY = Math.max(...starSeats.map(item => item.y + item.height));
			const newViewBoxMinWidthHeight = 210
			const viewBoxWidth = this.getCurrentViewBoxWidth()
			const newViewBoxWidth = Math.max(maxX - minX, newViewBoxMinWidthHeight) // new ViewBoxWidth should not be too small
			const newZoomFactorX = viewBoxWidth * this.state.zoomFactor / newViewBoxWidth
			const viewBoxHeight = this.getCurrentViewBoxHeight()
			const newViewBoxHeight = Math.max(maxY - minY, newViewBoxMinWidthHeight) // new ViewBoxHeight should not be too small
			const newZoomFactorY = viewBoxHeight * this.state.zoomFactor / newViewBoxHeight

			//take the min. factor (x|y) so that all stars are visible
			let newZoomFactor = Math.min(newZoomFactorX, newZoomFactorY) || 1


			if (newZoomFactor !== this.state.zoomFactor) {
				// The real size of the viewbox is calculated based on the zoom factor.
				// Proportions remain the same.
				const actuallyNewViewBoxWidth = this.props.maxX * (1 / newZoomFactor)
				const actuallyNewViewBoxHeight = this.props.maxY * (1 / newZoomFactor)
				const currentViewBox = this.getCurrentViewBox()

				// move viewBox so that star area is shown in the middle of the viewbox
				const newStartX = minX - (actuallyNewViewBoxWidth / 2) + (maxX - minX) / 2
				const newStartY = minY - (actuallyNewViewBoxHeight / 2) + (maxY - minY) / 2;
				const newViewBox = `${newStartX}` + ` ${newStartY}` + ` ${actuallyNewViewBoxWidth}` + ` ${actuallyNewViewBoxHeight}`;
				//set props in state to start the animation
				this.setState({
					viewBoxAnimationViewBoxTo: newViewBox,
					viewBoxAnimationViewBoxFrom: currentViewBox,
					viewBoxAnimationDur: '1.5'
				}, () => {
					setTimeout(() => {
						const animation = document.getElementById('viewBoxAnimation')
						animation.beginElement()
						//change props for the viewbox in state after animation has begun
						this.setState({
							startX: newStartX, startY: newStartY, zoomFactor: newZoomFactor,
						})
					}, 200)
				})
			}
		}
	}


	render() {
		const style = {
			msgContainer: {
				position: 'absolute', top: '1em', width: '100%', zIndex: '1',
			}, svg: {
				flex: 1,
			}, containerOuter: {
				display: 'flex', flexDirection: 'column', flexGrow: '1', position: 'relative',
			}, containerSvg: {
				display: 'flex',
				flexDirection: 'column',
				flexGrow: '1',
				position: 'relative',
				overflow: 'hidden',
				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: this.context.themeManager
					.value('seatingplan', 'borderColor', 'border-color-satingplan'),
			}, buttonContainer: {
				display: 'flex',
				justifyContent: 'space-between',
				margin: '0.5em 0 1.2em 0',
				flexWrap: 'wrap',
				'@media (min-width : 768px)': {
					margin: '1em 0 0.5em', flexWrap: 'nowrap',
				},
			}, titleContainer: {
				margin: '3em 0 0', '@media (min-width : 768px)': {
					margin: '4.5em 0 1.5em', padding: '0em',
				},
			},
		};
		const showAccessCodesForm = this.props.accessCodesRequired || this.state.enteringAccessCode;

		/* To really conditionally render the svg, we would have to change the svg handlers etc. significantly.
			So for now we just "display" it conditionally. */
		if (showAccessCodesForm) {
			style.svg.display = 'none';
			// Allow content to overflow (scroll) while access code form is open to prevent the lower buttons to squeeze over the form.
			style.containerOuter.display = 'block';
		} else {
			delete (style.svg.display);
			style.containerOuter.display = 'flex';
		}

		const viewBox = this.getCurrentViewBox()

		return (<div style={style.containerOuter}>
			{!showAccessCodesForm && <CategoryDropDown/>}
			<div style={style.msgContainer}>
				<Messages msgs={this.props.msgs} onRemoveMessage={this.props.removeMessage}/>
			</div>
			<div style={style.containerSvg}>
				{showAccessCodesForm && <ZigZagBox>
					<AccessCodeForm
						codeMandatory={this.props.accessCodesMandatory}
						onLeave={() => {
							this.setState({
								enteringAccessCode: false,
							}, () => {
								this.setNewZoomForStarSeats(this.props.starSeats);
							})
						}}/>
				</ZigZagBox>}
				<svg
					viewBox={viewBox}
					style={style.svg}
					ref={(el) => {
						this.el = el;
					}}
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					aria-labelledby="svg-title"
				>
					<title id="svg-title">interaktiver Saalplan für die Veranstaltung {this.props.event.title}</title>
                    <defs>
                        <pattern
                            id="diagonalHatch"
                            width="2" height="2"
                            patternUnits="userSpaceOnUse"
                            patternTransform="rotate(45)"

                        >
                            <rect width="2" height="2" fill="white" />
                            <line
                                x1="0" y1="0"
                                x2="0" y2="2"
                                stroke="#757575"
                                strokeWidth="1"
                            />
                        </pattern>
                    </defs>
					{this.props.showBackgroundImage && this.props.backgroundImage && <image
						x="0"
						y="0"
						aria-label={"Saalplan Hintergrundbild"}
						width={this.props.backgroundImage.width}
						height={this.props.backgroundImage.height}
						xlinkHref={this.props.backgroundImage.url}
						onDragStart={(e) => e.preventDefault()}
					/>}
					<SeatingplanElements elements={this.props.elements}/>
					<animate
						id="viewBoxAnimation"
						attributeName="viewBox"
						from={this.state.viewBoxAnimationViewBoxFrom}
						to={this.state.viewBoxAnimationViewBoxTo}
						dur={this.state.viewBoxAnimationDur + 's'}
						repeatCount="1"
						begin="indefinite"
					/>
				</svg>
			</div>
			<div style={style.buttonContainer}>
				<div className="button__container-element btn--back">
					<EventPageSeatingplanBtn
						eventUUID={this.props.event.uuid}
					/>
				</div>
				{this.props.showCodeBtn &&
					<div className="button__container-element btn--accesscodes">
						<Button
							name={'enterCode'}
							buttonText={'Code eingeben'}
							buttonContainerStyle={{width: '100%', height: '100%'}}
							btnStyle={'highlight'}
							iconName={'key'}
							onClick={() => {
								this.setState({enteringAccessCode: true});
							}}
							disabled={showAccessCodesForm}
						/>
					</div>}
				<div className="button__container-element btn--to-shoppingcart">
					<Button
						name="reservation_next"
						buttonText="Zum Warenkorb"
						btnStyle="highlight"
						onClick={() => this.props.onClickNext(this.props.event.uuid)}
						buttonContainerStyle={{width: '100%', height: '100%'}}
						iconName={'shopping-cart'}
						disabled={showAccessCodesForm || ((!this.props.selectedSeats.selectedSeats.length >= 1) && (!this.props.selectedSeats.selectedFreeSeatings.length >= 1))}
					/>
				</div>
			</div>
			{this.props.showFreeSeatingPopup && <LeoPopup
				headline={this.getBlockSeatPopupTitle(this.props.fsIdent)}
				onClose={this.props.closeFreeSeatingPopup}
				childComponent={<FreeSeatingAmountSelection/>}
			/>}
			{this.props.seatInSelection && <LeoPopup
				headline={this.getSeatPopupTitle(this.props.seatInSelection)}
				onClose={this.props.closeSeatPopup}
				childComponent={<SeatPricelevelSelection seatIdentifier={this.props.seatInSelection}/>}
			/>}
		</div>);
	}
}

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state) => {
	const seatingplan = state.seatingplan.elements[state.seatingplan.selected] || {};
	const elements = Object.keys(seatingplan).map(key => seatingplan[key]);
	const maxX = Math.max(...elements.map(el => el.x + el.width || 0));
	const maxY = Math.max(...elements.map(el => el.y + el.height || 0));
	const seatingplanElement = elements.find(element => element.type === 'SEATINGPLAN');
	const backgroundImage = seatingplanElement.backgroundImageBase64;
	const showBackgroundImage = seatingplanElement.showBgImgOnSale;
	const event = state.event.elements[state.event.selected] || {};
	const selectedSeats = state.selectedSeats;

	const accessCodesEnabled = state.accessCodes.accessCodesEnabled;
	const sponsorCodesEnabled = state.sponsorCodes.sponsorCodesEnabled;
	const partnershopMode = state.sponsorCodes.excludePublicSeats;
	const accessCodesMandatory = state.accessCodes.accessCodesMandatory;
	const accessCodesPlUuidCodeMap = state.accessCodes.plUuidCodeMap;
	const accessCodesRequired = accessCodesEnabled && accessCodesMandatory && (Object.keys(accessCodesPlUuidCodeMap).length === 0);
	const showCodeBtn = !partnershopMode && ((accessCodesEnabled && !accessCodesMandatory) || sponsorCodesEnabled)

	const redeemedSponsorCodeUsages = Object.keys(state.sponsorCodes.codeUsagesPlUuidMap)
	const sponsorReservations = state.sponsorCodes.seatReservations || [];
	// we need the uuids of all star-seats to bring these elements to front because of the animation
	let starSeats = []
	elements.forEach(element => {
		if (element.type === 'SEAT' && // same rule for showing star elements as in Seat.jsx
			sponsorCodeService.isSeatForRedeemedSponsorCodeReserved(sponsorReservations, getSeatIdentifier(element), redeemedSponsorCodeUsages)) {
			starSeats.push(element)
		}
	})

	return {
		seatingplan,
		elements,
		maxX,
		maxY,
		venue: state.venue.elements[event.venueId] || {},
		event,
		selectedSeats,
		backgroundImage,
		showBackgroundImage,
		showFreeSeatingPopup: state.seatingplanPageReducer.showFreeSeatingPopup,
		seatInSelection: state.seatingplanPageReducer.seatInSelection,
		fsIdent: state.seatingplanPageReducer.selectedFreeSeating,
		msgs: state.seatingplanPageReducer.messages,
		accessCodesRequired,
		showCodeBtn,
		starSeats,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeFreeSeatingPopup: () => dispatch(toggleShowFreeSeatingPopup()),
	closeSeatPopup: () => dispatch(setSeatInSelection(null)),
	onClickNext: (eventUuid) => {
		const shoppingCartCheckoutUrl = `sp/${eventUuid}/shoppingcart`;
		history.push(shoppingCartCheckoutUrl);
	},
	removeMessage: (msg) => {
		dispatch(deleteMessage(msg))
	}
});

SeatingplanDisplayPage.contextType = ThemeContext;


export default connect(mapStateToProps, mapDispatchToProps)(radium(SeatingplanDisplayPage));
